<template>
  <button type="button" class="rr-row" @click="$emit('open', reminder)">
    <span class="rr-row-icon" :class="`rr-tone--${reminder.urgency.key}`">
      <v-icon size="18" class="rr-row-icon-glyph">mdi-car-outline</v-icon>
    </span>
    <span class="rr-row-main">
      <span class="rr-row-title">{{ reminder.title }}</span>
      <span class="rr-row-sub">{{ reminder.subtitle }} · {{ reminder.policyNo }}</span>
      <span class="rr-row-nudge">{{ reminder.nudge }}</span>
    </span>
    <span class="rr-row-side">
      <span class="rr-chip" :class="`rr-tone--${reminder.urgency.key}`">{{ reminder.urgency.label }}</span>
      <span class="rr-row-due">{{ reminder.dueText }}</span>
      <span class="rr-row-date">{{ reminder.dateText }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'RenewalReminderRow',
  props: {
    reminder: { type: Object, required: true },
  },
};
</script>

<style scoped>
.rr-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 9px 18px;
  text-align: left;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: background 0.15s;
}

.rr-row:hover,
.rr-row:focus-visible {
  background: #F4F7FB;
  outline: none;
}

.rr-row-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rr-row-icon-glyph {
  color: inherit !important;
}

.rr-row-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.rr-row-title {
  font-size: 0.86rem;
  font-weight: 800;
  color: #1E4276;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rr-row-sub {
  font-size: 0.72rem;
  color: #64748B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rr-row-nudge {
  margin-top: 2px;
  font-size: 0.72rem;
  color: #475569;
  line-height: 1.35;
}

.rr-row-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.rr-chip {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 800;
  white-space: nowrap;
}

.rr-row-due {
  font-size: 0.72rem;
  font-weight: 700;
  color: #1E4276;
  white-space: nowrap;
}

.rr-row-date {
  font-size: 0.68rem;
  color: #94A3B8;
  white-space: nowrap;
}

.rr-tone--ended { background: #FED7D7; color: #9B2C2C; }
.rr-tone--now { background: #FEEBC8; color: #9C4221; }
.rr-tone--soon { background: #E0F2FE; color: #075985; }
.rr-tone--upcoming,
.rr-tone--ready { background: #E8EEF7; color: #1E4276; }
</style>
